import { get, push, ref, update } from "firebase/database";
import { database } from "../../../Utils/firebase";
import GetCustomersData from "../../Comman/GetCustomersData";
import { v4 as uuidv4 } from "uuid"; // For unique ledger IDs

const AddLedgerCustomerDataInFirebase = async (state, dispatch, customerData, userID, isEditing) => {
    const USERID = state?.USERID || userID;
    if (!USERID) return null;

    try {
        const customerRef = ref(database, `invoiceGenerator/users/${USERID}/customers`);
        const snapshot = await get(customerRef);
        const existingCustomers = snapshot.val();


        let isCustomerExist = false;
        let existingCustomerKey = null;
        let existingCustomerData = null;

        if (snapshot.exists()) {
            Object.entries(existingCustomers).forEach(([key, customer]) => {
                if (
                    customer.customer?.toLowerCase() ===
                    customerData.customer?.toLowerCase()
                ) {
                    isCustomerExist = true;
                    existingCustomerKey = key;
                    existingCustomerData = customer;
                }
            });
        }
        if (!isCustomerExist) {
            // 🆕 New Customer
            const cleanedCustomer = {
                createdBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
                createdById: state?.USERID || null,
                updatedBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
                updatedById: state?.USERID || null,
                ...customerData,
                customerId:
                    customerData.customerId?.toString() || Date.now().toString(),
                createdAt: Date.now().toString(),
                updatedAt: Date.now().toString(),
                invoiceCount: "1",
                //invoices: [customerData.invoices?.[0] || ""],
                totalPaid: "0",
                paymentsReceived: [
                    {
                        id: uuidv4(),
                        date: Date.now().toString(),
                        note: customerData?.ledger?.note || "",
                        amount: Number(customerData?.ledger?.amount || 0).toString(),
                        paymentMode: customerData?.ledger?.paymentMode || "",
                        type: "credit",
                        currency: customerData?.ledger?.currency || "",
                    },
                ],
            };

            await push(customerRef, cleanedCustomer);
        } else {
            // 🆕 Existing Customer
            const itemUpdateRef = ref(
                database,
                `invoiceGenerator/users/${USERID}/customers/${existingCustomerKey}`
            );

            let updatedLedger;


            if (isEditing && customerData?.ledger?.id) {
                // ✅ Use paymentsReceived instead of ledger
                updatedLedger = (existingCustomerData?.paymentsReceived || []).map((entry) =>
                    entry.id === customerData.ledger.id
                        ? {
                            ...entry,
                            date: customerData?.ledger?.date?.toString() || entry.date,
                            amount: customerData?.ledger?.amount?.toString() || entry.amount,
                            note: customerData?.ledger?.note ?? entry.note,
                            paymentMode: customerData?.ledger?.paymentMode ?? entry.paymentMode,
                            currency: customerData?.ledger?.currency || entry.currency || "",
                            updatedAt: Date.now().toString(),
                        }
                        : entry
                );
            } else {
                // ➕ Adding new ledger entry
                const newLedgerEntry = {
                    createdBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
                    updatedBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
                    id: customerData?.ledger?.id || uuidv4(),
                    date: Date.now().toString(),
                    note: customerData?.ledger?.note || "",
                    amount: Number(customerData?.ledger?.amount || 0).toString(),
                    paymentMode: customerData?.ledger?.paymentMode || "",
                    type: "credit",
                    currency: customerData?.ledger?.currency || ""
                };

                updatedLedger = existingCustomerData?.paymentsReceived
                    ? [...existingCustomerData.paymentsReceived, newLedgerEntry]
                    : [newLedgerEntry];
            }


            // ✅ Clean undefined values before updating Firebase
            const cleanedUpdateData = Object.fromEntries(
                Object.entries({
                    ...existingCustomerData,
                    dialCode: customerData?.dialCode || customerData?.dial_code,
                    phone: customerData?.phone,
                    email: customerData?.email,
                    address: customerData?.address,
                    customerGSTNo: customerData?.customerGSTNo,
                    updatedAt: Date.now().toString(),
                    paymentsReceived: updatedLedger, // ✅ correct key
                }).filter(([_, value]) => value !== undefined)
            );


            await update(itemUpdateRef, cleanedUpdateData);
            await GetCustomersData(state, dispatch);
        }
    } catch (error) {
        console.log("❌ Error fetching data:", error);
        return null;
    }
};

export default AddLedgerCustomerDataInFirebase;
